<template>
  <div class="icon-wrapper form-group" :class="{ 'has-radios': control }">
    <a
      :name="bank.code"
      class="icon-col"
      href="#"
      :class="{ active: isActive(bank) }"
      @click="selectBank($event, bank)"
      v-for="bank in banks"
      :key="bank.code"
    >
      <img :src="pathFor(bank.code)" width="140" height="46">
      <i class="radio i-circle" />
    </a>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    control: { type: Boolean, default: false },
    banks: Array,
  },
  methods: {
    selectBank(event, bank) {
      event.preventDefault();
      this.$emit('input', bank.code);
    },

    isActive(bank) {
      return this.control && this.value === bank.code;
    },

    pathFor(icon) {
      return new URL(`../assets/img/banks/${icon}.png`, import.meta.url).href;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

.radio,
.hide {
  display: none;
}

.has-radios {
  .radio {
    display: block;
  }
}
</style>
